<template>
	<div>
		<ModalDetailProduk :product="selectedProduct" ref="modalDetail"></ModalDetailProduk>
		<ModalConfirm ref="modalConfirm" :msg="msgConfirm" :params="params" @action="processPurchase"></ModalConfirm>
		<ModalSuccess ref="modalSuccess" :msg="msgSuccess" :link="link"></ModalSuccess>
		<ModalFailed ref="modalFailed" :msg="msgFailed"></ModalFailed>
		<v-row class="ml-0 mt-3 body-transaction-product">
			<v-col cols="12" sm="4" md="3" xl="2" class="pl-0 pt-0 col-md-20 d-flex flex-stretch" v-for="product in listProductAll" :key="product.product_id">
				<v-card class="pa-3 elevation-0 rounded-lg hover-shadow h-100">
					<a href="javascript:void(0)" title="Klik untuk melihat detail Produk" @click="showDetailProduct(product)">
						<v-img contain height="165px" class="rounded-lg" :src="(product.product_image) ? product.product_image : '/assets/image/user-pict.jpg'"></v-img>
					</a>
					<div class="pt-3">
						<div class="font-size-12 product-name font-weight-600 mb-2">{{ product.product_name }}</div>
						<div class="font-size-10 cl-secondary">Stok Anda : <b :class="{'red--text': product.product_qty === 0}" >{{ (product.product_qty > 0) ? product.product_qty : 'HABIS' }}</b></div>
						<div class="font-size-12 cl-primary">{{ product.product_member_price | toRupiah }}</div>
					</div>
					<div class="checked-input mt-2 mb-1" :class="(!product.checked) ? 'grey lighten-4' : 'orange lighten-5'">
						<v-checkbox hide-details class="mt-0 pt-0 mr-0" :class="{'green--text' : product.checked}" label="Beli Produk" on-icon="mdi-check-circle" off-icon="mdi-checkbox-blank-circle-outline" v-model="product.checked" @click="checkBuy(product, product.product_id)"></v-checkbox>
					</div>
					<v-row class="pt-2 justify-space-between align-center">
						<v-col cols="2" sm="3" md="3" xl="3" class="">
							<v-btn elevation="0" small :disabled="!product.checked" @click="decQty(product)" class="px-0" style="min-width: 33px;">
								<v-icon color="error">mdi-minus-circle-outline</v-icon>
							</v-btn>
						</v-col>
						<v-col cols="8" sm="6" md="6" xl="6" class="px-0">
							<div class="">
								<v-text-field dense hide-details="auto" v-model="product.quantity" :disabled="!product.checked" @keypress="onlyNumber" @keyup="addTotal(product)" @paste.prevent :rules="rules.inputQty"></v-text-field>
							</div>
						</v-col>
						<v-col cols="2" sm="3" md="3" xl="3" class="">
							<v-btn elevation="0" small :disabled="!product.checked" @click="addQty(product)" class="px-0 flex-shrink-0" style="min-width: 33px;">
								<v-icon color="primary">mdi-plus-circle-outline</v-icon>
							</v-btn>
						</v-col>
					</v-row>
				</v-card>
			</v-col>
		</v-row>
		<div class="footer-transaction-product rounded-lg">
			<div class="d-flex flex-column flex-md-row">
				<v-col cols="12" md="6" class="pa-0">
					<div class="font-size-11 product-name"><b>{{ firstData.length }}</b> Item produk dipilih</div>
					<div class="font-size-14 cl-primary">{{ sumTotal | toRupiah }}</div>
				</v-col>
				<v-col cols="12" md="6" class="pa-0 text-right my-auto d-none d-md-block">
					<v-btn large width="120" depressed color="primary" class="rounded-lg" :disabled="firstData.length == 0" @click="showConfirm">
						<v-icon>mdi-cart-arrow-right</v-icon>
						<span class="pl-2">Beli</span>
					</v-btn>
				</v-col>
				<v-col cols="12" md="6" class="pa-0 text-right my-auto d-block d-md-none">
					<v-btn block large width="120" depressed color="primary" class="rounded-lg mt-3" :disabled="firstData.length == 0" @click="showConfirm">
						<v-icon>mdi-cart-arrow-right</v-icon>
						<span class="pl-2">Beli</span>
					</v-btn>
				</v-col>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalConfirm from '@/components/modals/vo/ModalConfirm';
import ModalSuccess from '@/components/modals/vo/ModalSuccess';
import ModalFailed from '@/components/modals/vo/ModalFailed';
import ModalDetailProduk from './ModalDetailProduk';

export default {
	components: {
		ModalDetailProduk, ModalConfirm, ModalSuccess, ModalFailed
	},
	data() {
		return {
			firstData: [],
			selectedProduct: null,
			params: {},
			msgConfirm: "Yakin ingin memproses pembelian?",
			msgSuccess: "Selamat! Anda berhasil melakukan pembelian produk. Untuk selanjutnya silahkan menunggu proses Approval terlebih dahulu. Untuk detail Pemesanan bisa di",
			msgFailed: "Mohon Maaf transaksi Anda Gagal. Silakan ulangi kembali untuk melakukan pembelian Produk Anda",
			link: "lap-belanja-produk-stockist",
			rules: {
				inputQty: [
					v => parseFloat(v) < 1001 || 'Jumlah pembelian maksimal 1000',
				],
			}
		}
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState('product', ['listProductAll']),

		sumTotal() {
			let total = 0
			this.firstData.forEach((el) => {
				total += parseInt(el.total)
			})
			return total
		}
	},
	methods: {
		...mapActions('product', ['getProductAll']),
		...mapActions('transactionProduct', ['addTransactionProductStockist']),

		showDetailProduct(product) {
			this.selectedProduct = product
			this.$refs.modalDetail.modalShow()
		},

		getData() {
			this.getProductAll()
		},
		checkBuy(product, id) {
			if (product.checked == true) {
				this.firstData.push(product)
			} else {
				this.firstData = this.firstData.filter(function(item) {
					return item.product_id !== id
				})
			}
		},
		addQty(product) {
			if (product.quantity >= 0) {
				product.quantity++
				product.total = product.quantity * product.product_member_price
			}
		},
		decQty(product) {
			if (product.quantity > 1) {
				product.quantity--
				product.total = product.quantity * product.product_member_price
			}
		},
		addTotal(product) {
			if (product.quantity <= 0) {
				product.quantity = 1
			}
			product.total = product.quantity * product.product_member_price
		},
		processTransaction() {
			let data = this.firstData
			let product_id = []
			let product_qty = []
			data.forEach((res) => {
				let id = res.product_id;
				let qty = res.quantity;
				product_id.push(id);
				product_qty.push(qty);
			})
			this.params = {product_id,product_qty}
		},
		showConfirm() {
			this.processTransaction()
			this.$refs.modalConfirm.modalShow()
		},
		processPurchase() {
			this.$refs.modalConfirm.loadingButton()
			this.addTransactionProductStockist(this.params).then(() => {
				this.$refs.modalConfirm.normalButton()
				this.$refs.modalConfirm.modalHide()
				this.$refs.modalSuccess.modalShow()
				this.firstData = []
				this.params = {}
				this.getData()
			}).catch(() => {
				this.$refs.modalConfirm.normalButton()
				this.$refs.modalConfirm.modalHide()
				this.$refs.modalFailed.modalShow()
			})
		}
	},
	created(){
		this.getData()
	},
};
</script>
